window.__POD_CFG={"shopID":"69e657a1f69a1d59efcba0f6","SHOP_MY_SHOPIFY_DOMAIN":"jpj3m8-34.myshopify.com","POD_APP_URL":"https://pod.pixelflowdtf.com","POD_EDGE_URL":"https://podflowsls.pixelflowdtf.com","PODenabledProductList":["8426112319679","8410794066111","8410794033343","8410793803967","8410793771199","8426112090303","8426111631551","8410793902271","8426111369407"]};
/**
 * POD Storefront Integration Script
 *
 * Deployed into the Shopify theme as `assets/desi.js`.
 * `deployDesiAsset.ts` prepends `window.__POD_CFG = { ... };` before this IIFE
 * to inject runtime values (shopID, product list, app URL, shop domain).
 *
 * Design goals (matches reference script behavior — theme‑elastic, no infinite loops):
 *  - Scope DOM work to `form[action="/cart/add"]` (simple, works across themes)
 *  - Physically REMOVE native buy buttons / payment wrappers (no `display:none`
 *    fights with theme CSS and no MutationObserver re‑entry loops)
 *  - Re‑run only on user variant change clicks (event‑driven, not observer‑driven)
 *  - Bounded ShopifyAnalytics poller (stops after 15s)
 *  - No perpetual setInterval / no MutationObserver
 *
 * Responsibilities:
 *  - Detect POD‑enabled products on /products/ pages
 *  - Replace native "Add to Cart" with "Customize Your Design" (unique class
 *    `pod-flow-desi-customize-btn`, never shared with other builder snippets)
 *  - Open the POD designer as a full‑screen iframe modal
 *  - Handle cart add flow on /cart pages (?items=...&oldVariantId=...) only for
 *    POD-enabled products (skips unified `dtf.js` GangSheet / DTF / UGS payloads)
 *  - Handle /cart/<variantId:qty> permalinks (avoid add‑loop)
 *  - Listen for postMessage from the designer to close / add to cart
 *  - Hide internal cart properties (_pod_session_id, _pod_preview, _pod_product_id, _timestamp)
 */
(function () {
  // ── Configuration (injected by server) ────────────────────────
  var config = window.__POD_CFG || {};
  var isDebug = config._debug || false;
  var shopID = String(config.shopID || "");
  var enabledList = Array.isArray(config.PODenabledProductList)
    ? config.PODenabledProductList
    : [];
  var APP_URL = String(config.POD_APP_URL || "").replace(/\/$/, "");
  var SHOP_DOMAIN = String(config.SHOP_MY_SHOPIFY_DOMAIN || "");
  var POD_EDGE_URL = String(config.POD_EDGE_URL || "").replace(/\/$/, "");
  var FEE_VARIANT_ID = String(config.customizationFeeVariantId || "").trim();
  var FEE_VARIANT_UNIT = parseFloat(config.customizationFeeVariantUnit) || 0.01;
  var _resolvedShopId = shopID;

  function resolveRuntimeShopId() {
    if (_resolvedShopId) return Promise.resolve(_resolvedShopId);
    if (!SHOP_DOMAIN || !POD_EDGE_URL) return Promise.resolve("");
    return fetch(
      POD_EDGE_URL +
        "/api/shop-cart-config?shop=" +
        encodeURIComponent(SHOP_DOMAIN)
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var id = data && data.shopId ? String(data.shopId).trim() : "";
        if (id) _resolvedShopId = id;
        return id;
      })
      .catch(function () {
        return "";
      });
  }

  // Unique to POD — must NOT match third‑party snippets (e.g. GangSheet uses
  // `my-custom-add-button`); sharing that class caused both apps to open.
  var BTN_CLASS = "pod-flow-desi-customize-btn";
  var BTN_DATA_ATTR = "data-pod-flow-designer";
  // Full‑screen designer modal id
  var MODAL_ID = "pod-custom-modal";
  // Confirm dialog when closing the designer (parent page)
  var CONFIRM_ID = "pod-designer-close-confirm";
  // Console log prefix
  var TAG = "[POD]";

  // ── Logging ───────────────────────────────────────────────────

  function log() {
    if (isDebug) {
      console.log.apply(console, [TAG].concat([].slice.call(arguments)));
    }
  }

  // ── ID Normalization ──────────────────────────────────────────
  // Shopify IDs can be numeric, string, or GID (gid://shopify/Product/123)

  function normalizeId(value) {
    if (value == null) return "";
    var str = String(value).trim();
    if (!str) return "";
    // Pull the numeric tail out of a GID
    var gidMatch =
      /^gid:\/\/shopify\/(?:Product|ProductVariant)\/(\d+)$/.exec(str);
    return gidMatch ? gidMatch[1] : str;
  }

  function idsEqual(a, b) {
    var normA = normalizeId(a);
    var normB = normalizeId(b);
    return !(!normA || !normB) && normA === normB;
  }

  function isProductInEnabledList(id) {
    if (!id) return false;
    for (var i = 0; i < enabledList.length; i++) {
      if (idsEqual(enabledList[i], id)) return true;
    }
    return false;
  }

  // ── Shopify Analytics Helpers ─────────────────────────────────

  function getProductVariantFromAnalytics() {
    var result = { productId: "", variantId: "" };
    try {
      var meta =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product;
      if (meta) {
        if (meta.id != null) {
          result.productId = normalizeId(meta.id);
        }
        if (meta.selected_or_first_available_variant != null) {
          result.variantId = normalizeId(
            meta.selected_or_first_available_variant
          );
        } else if (
          Array.isArray(meta.variants) &&
          meta.variants.length &&
          meta.variants[0] &&
          meta.variants[0].id != null
        ) {
          result.variantId = normalizeId(meta.variants[0].id);
        }
      }
    } catch (e) {
      /* silently ignore */
    }
    return result;
  }

  /**
   * Get product ID from form hidden input, ShopifyAnalytics, or window.meta.
   */
  function getProductId() {
    try {
      var form = document.querySelector(
        'form[action="/cart/add"],form[action*="/cart/add"]'
      );
      if (form) {
        var input = form.querySelector(
          'input[name="product-id"],input[name="product_id"]'
        );
        if (input && input.value) return normalizeId(input.value);
      }
    } catch (e) {
      /* ignore */
    }

    var analytics = getProductVariantFromAnalytics().productId;
    if (analytics) return analytics;

    try {
      if (window.meta && window.meta.product && window.meta.product.id != null) {
        return normalizeId(window.meta.product.id);
      }
    } catch (e) {
      /* ignore */
    }
    return "";
  }

  /**
   * Get variant ID from form inputs, ShopifyAnalytics, Shopify.selectedVariant,
   * or the form's data attribute.
   */
  function getVariantId(form) {
    if (form) {
      var input =
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[name="variant_id"]') ||
        form.querySelector('[name="id"]') ||
        form.querySelector('input[type="hidden"][name*="variant"]');
      if (input && input.value) return normalizeId(input.value);
      if (form.dataset && form.dataset.variantId)
        return normalizeId(form.dataset.variantId);
    }

    var analytics = getProductVariantFromAnalytics().variantId;
    if (analytics) return analytics;

    try {
      if (typeof Shopify !== "undefined" && Shopify.selectedVariant) {
        var sv = Shopify.selectedVariant;
        return normalizeId(
          typeof sv === "object" && sv.id != null ? sv.id : sv
        );
      }
    } catch (e) {
      /* ignore */
    }
    return "";
  }

  /**
   * Is the current /products/... page for a POD‑enabled product?
   */
  function isCurrentProductEnabled() {
    var pathname = window.location.pathname || "";
    if (pathname.indexOf("/products/") === -1) return false;
    var analytics = getProductVariantFromAnalytics();
    var pid = getProductId() || analytics.productId;
    if (!pid) return false;
    return (
      isProductInEnabledList(pid) || isProductInEnabledList(analytics.variantId)
    );
  }

  // ── Build / Locate / Insert Custom Button ─────────────────────

  /**
   * Apply POD brand styling to a button. Uses `!important` so our colors
   * win over theme CSS that targets the cloned classes (e.g. when we
   * inherit `.product-form__submit` the theme may set its own background
   * color with high specificity — `!important` inline beats it).
   *
   * IMPORTANT: we only override VISUAL properties (color / background /
   * border / cursor / text). We do NOT touch layout properties (width,
   * padding, margin, display, position, flex, grid, order), so the
   * button keeps whatever layout rules the theme applied to the ATC.
   */
  function applyBrandStyle(btn) {
    btn.style.setProperty("background", "#000", "important");
    btn.style.setProperty("background-color", "#000", "important");
    btn.style.setProperty("background-image", "none", "important");
    btn.style.setProperty("color", "#fff", "important");
    btn.style.setProperty("border", "none", "important");
    btn.style.setProperty("cursor", "pointer", "important");
    btn.style.setProperty("text-transform", "none", "important");
    btn.style.setProperty("opacity", "1", "important");
  }

  /**
   * Apply default LAYOUT styling (used only in the fallback path when no
   * native ATC button was found to clone from). Gives us a reasonable
   * standalone look.
   */
  function applyDefaultLayoutStyle(btn) {
    btn.style.width = "100%";
    btn.style.padding = "14px";
    btn.style.fontSize = "16px";
    btn.style.borderRadius = "6px";
    btn.style.marginTop = "10px";
  }

  /**
   * Create the POD "Customize Your Design" button element.
   * Only brand styles are applied here — layout is inherited from cloned
   * ATC classes OR applied via `applyDefaultLayoutStyle` in fallback.
   */
  function buildCustomBtn() {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.innerText = "Customize Your Design";
    btn.className = BTN_CLASS;
    btn.setAttribute(BTN_DATA_ATTR, "1");
    applyBrandStyle(btn);
    return btn;
  }

  /**
   * Identify the REAL "Add to Cart" button in a form, in priority order.
   * This is far more reliable than the first `button[type="submit"]` — many
   * themes have multiple submit buttons (sticky ATC, quick‑view, variant
   * popups) and we need to pick the main one.
   *
   * Priority:
   *  1. `button[name="add"]`             — Shopify's canonical ATC attribute
   *  2. `.product-form__submit`          — Dawn / Debut / many stock themes
   *  3. `button[data-add-to-cart]`       — custom themes
   *  4. `button.btn--add-to-cart`        — Impulse / some custom themes
   *  5. `button.add-to-cart`             — Impulse / generic
   *  6. `button.add-to-cart-button`      — generic
   *  7. `button[id^="ProductSubmit"]`    — older Shopify theme ids
   *  8. `button[id^="AddToCart"]`        — older variants
   *  9. first `button[type="submit"]`    — last resort
   *  10. first `input[type="submit"]`    — last resort (old themes)
   */
  function findAddToCartButton(form) {
    if (!form) return null;
    var selectors = [
      'button[name="add"]',
      "button.product-form__submit",
      ".product-form__submit",
      "button[data-add-to-cart]",
      "button.btn--add-to-cart",
      "button.add-to-cart",
      "button.add-to-cart-button",
      'button[id^="ProductSubmit"]',
      'button[id^="addToCart"]',
      'button[id^="AddToCart"]',
      'button[type="submit"]',
      'input[type="submit"]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = form.querySelector(selectors[i]);
      // Never match our POD button, DTF, or another app’s `.my-custom-add-button`.
      if (
        el &&
        !el.classList.contains(BTN_CLASS) &&
        !el.classList.contains("dtf-custom-upload-button") &&
        !el.classList.contains("my-custom-add-button")
      ) {
        return el;
      }
    }
    return null;
  }

  /**
   * Swap the POD button INTO the exact DOM position of the native ATC button
   * and INHERIT its layout styling from the theme.
   *
   * Two mechanisms together guarantee the POD button stays in place:
   *
   *  1. DOM position — `replaceWith()` puts the POD button in the same
   *     parent at the same index as the original ATC button.
   *  2. Visual layout — we CLONE the original's `class` attribute AND its
   *     inline `style` attribute onto the POD button. This carries over
   *     every theme rule that was sizing / positioning the ATC (flex order,
   *     grid-area, width, padding, margin, display, etc).
   *
   * Our POD brand colors are then re‑applied with `!important` so they
   * beat any cloned theme CSS that would otherwise repaint the button.
   *
   * Returns the inserted POD button, or null if no ATC was found (caller
   * handles the fallback).
   */
  function replaceAtcWithPodBtn(form) {
    if (form.querySelector("." + BTN_CLASS)) {
      return form.querySelector("." + BTN_CLASS);
    }
    var atc = findAddToCartButton(form);
    if (!atc) return null;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.innerText = "Customize Your Design";
    btn.setAttribute(BTN_DATA_ATTR, "1");

    // --- Clone CLASS: theme's position / layout CSS applies to us ---
    var atcClass = "";
    if (typeof atc.className === "string") {
      atcClass = atc.className;
    } else if (atc.getAttribute && atc.getAttribute("class")) {
      // SVG / custom elements can expose className as an object — fall back
      // to the raw attribute string.
      atcClass = atc.getAttribute("class") || "";
    }
    btn.className = (atcClass ? atcClass + " " : "") + BTN_CLASS;

    // --- Clone inline STYLE: some themes set position inline (order,
    //     grid-area, width, margin, etc). Preserve those exactly. ---
    var inlineStyle = atc.getAttribute("style");
    if (inlineStyle) {
      btn.setAttribute("style", inlineStyle);
    }

    // --- Clone a few layout‑relevant data/aria attributes so CSS
    //     selectors that target them still match (e.g. `[data-size="lg"]`). ---
    var attrsToClone = ["data-size", "data-variant", "data-style"];
    for (var ai = 0; ai < attrsToClone.length; ai++) {
      var val = atc.getAttribute(attrsToClone[ai]);
      if (val != null) btn.setAttribute(attrsToClone[ai], val);
    }

    // --- Apply POD brand styling AFTER cloning so it wins visually ---
    //     Uses `!important` so theme class rules can't repaint us.
    applyBrandStyle(btn);

    // --- Swap into the ATC's exact DOM slot ---
    try {
      atc.replaceWith(btn);
    } catch (e) {
      // Old browsers without `replaceWith` — insertBefore + remove fallback.
      if (atc.parentNode) {
        atc.parentNode.insertBefore(btn, atc);
        try {
          atc.remove();
        } catch (_) {
          /* ignore */
        }
      } else {
        return null;
      }
    }
    return btn;
  }

  /**
   * Fallback insertion: used when we can't find a native ATC button to
   * swap with. Mirrors the reference script's container selector list.
   * Since we have no theme class/style to clone, we apply the default
   * POD layout styling so the button still looks correct.
   */
  function insertCustomBtnFallback(form) {
    if (form.querySelector("." + BTN_CLASS)) return;
    var btn = buildCustomBtn();
    // No ATC to inherit layout from — use our own layout defaults.
    applyDefaultLayoutStyle(btn);
    var target = form.querySelector(
      ".product-form__buttons," +
        ".product-form," +
        ".product-single__form," +
        ".product__buttons," +
        "[data-product-form-buttons]," +
        "buy-buttons," +
        ".product-form__checkout," +
        ".product-form__checkout-buttons"
    );
    if (target) {
      target.appendChild(btn);
      return;
    }
    form.appendChild(btn);
  }

  // ── Form Selection ────────────────────────────────────────────

  /**
   * Is this a helper/auxiliary cart/add form (installment calculator,
   * Shop Pay widget, wishlist form, sticky bar, etc.) that should NOT
   * receive our POD button?
   *
   * Dawn, for example, renders a separate `class="installment"` form
   * that posts to /cart/add purely as a data holder for the Shop Pay
   * installment estimator. It contains no ATC button, and inserting
   * our POD button into it places the button in the wrong section
   * (near the top of the product info, above the variant selects).
   */
  function isAuxiliaryCartForm(form) {
    if (!form || !form.classList) return false;
    if (form.classList.contains("installment")) return true;
    if (form.classList.contains("shopify-payment-button")) return true;
    if (form.classList.contains("installment__form")) return true;
    // Dawn marks the REAL ATC form with data-type="add-to-cart-form".
    // If any sibling cart/add form has that attribute and this one doesn't,
    // we should treat this one as auxiliary (handled in the picker below
    // — we prefer data-type matches).
    return false;
  }

  /**
   * Pick the cart/add form that actually contains the "Add to Cart" button.
   *
   * Priority:
   *  1. A form with `data-type="add-to-cart-form"` (Dawn canonical marker).
   *  2. A form that contains a detectable ATC button.
   *  3. The first non-auxiliary form.
   *  4. The first form (last resort).
   */
  function pickMainCartForm(forms) {
    if (!forms || !forms.length) return null;

    // 1. Prefer forms explicitly marked as the add-to-cart form
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].getAttribute("data-type") === "add-to-cart-form") {
        return forms[i];
      }
    }

    // 2. Prefer forms that actually contain an ATC button
    for (var j = 0; j < forms.length; j++) {
      if (isAuxiliaryCartForm(forms[j])) continue;
      if (findAddToCartButton(forms[j])) return forms[j];
    }

    // 3. First non-auxiliary form
    for (var k = 0; k < forms.length; k++) {
      if (!isAuxiliaryCartForm(forms[k])) return forms[k];
    }

    // 4. Last resort
    return forms[0];
  }

  // ── Main Button Replacement (mirrors reference: remove, don't hide) ───

  /**
   * Replace the native Add‑to‑Cart form with our custom POD button.
   *
   * Key elasticity rules:
   *  - Operate on ONE form per page: the REAL add‑to‑cart form (selected
   *    via `pickMainCartForm`). Auxiliary forms (installment calculators,
   *    Shop Pay widgets, wishlist forms) are left entirely untouched.
   *  - Swap POD button INTO the native ATC button's slot via `replaceWith`
   *    so position is preserved exactly (same parent, same DOM index).
   *  - Clone the ATC button's className + inline style so theme layout
   *    CSS continues to govern positioning. Brand overrides are inline
   *    with `!important`.
   *  - No MutationObserver. We only re‑run on variant change interactions.
   */
  function replaceWithCustomAddToCartButton() {
    var forms = document.querySelectorAll(
      'form[action="/cart/add"],form[action*="/cart/add"]'
    );
    log("replace called, forms=", forms.length);

    // Pick the REAL add-to-cart form. Do NOT remove the other forms —
    // some themes use additional /cart/add forms as data holders for
    // installment calculators, sticky bars, etc., and removing them
    // would break those features or shift other elements on the page.
    var form = pickMainCartForm(forms);
    if (!form) {
      log("no cart/add form found");
      return;
    }

    // Do not interfere if DTF integration has already taken over this form
    if (form.querySelector(".dtf-custom-upload-button")) {
      log("DTF button present — skipping");
      return;
    }

    // Already has our button — nothing to do
    if (form.querySelector("." + BTN_CLASS)) {
      log("POD button already present — skipping");
      return;
    }

    // --- Step 1: Swap POD button INTO the native ATC button's slot ---
    // This is the key to preserving position across all themes: we replace
    // the "Add to Cart" element in place, so the POD button ends up at the
    // exact same DOM index in the exact same parent. The theme's class /
    // inline style is cloned onto our button so its layout CSS still applies.
    var podBtn = replaceAtcWithPodBtn(form);
    if (podBtn) {
      log("POD button swapped into ATC slot");
    } else {
      log("no native ATC found — using fallback placement");
    }

    // --- Step 2: Remove any OTHER native submit-like buttons ---
    // (e.g. a secondary "Buy it now" button rendered as <button type="submit">,
    // quick-view submits, etc.) Skip the POD button itself.
    var buttons = form.querySelectorAll(
      'button[type="submit"],input[type="submit"],button[type="button"],' +
        'button[name="add"],button[data-add-to-cart]'
    );
    buttons.forEach(function (b) {
      if (
        !b.classList.contains(BTN_CLASS) &&
        !b.classList.contains("dtf-custom-upload-button") &&
        !b.classList.contains("my-custom-add-button")
      ) {
        try {
          b.remove();
        } catch (e) {
          /* ignore */
        }
      }
    });

    // --- Step 3: Remove theme spinners ---
    form
      .querySelectorAll(".loading__spinner,.loading-overlay__spinner")
      .forEach(function (s) {
        try {
          s.remove();
        } catch (e) {
          /* ignore */
        }
      });

    // --- Step 4: Remove accelerated checkout / Shop Pay / PayPal etc. ---
    // Some themes render these inside the form; others outside it. We remove
    // all we find anywhere inside the form scope (loop until none remain).
    var paymentSelectors =
      '[data-shopify="payment-button"],' +
      ".shopify-payment-button," +
      ".additional-checkout-buttons," +
      "shopify-accelerated-checkout," +
      "shopify-paypal-button," +
      ".dynamic-checkout__content," +
      ".wallet-buttons-container," +
      ".wallet-button," +
      '[class*="shopify-payment-button"],' +
      '[class*="accelerated-checkout"],' +
      '[id*="shopify-installments"],' +
      ".installment__container," +
      ".product__payment-container";
    var paymentEl = form.querySelector(paymentSelectors);
    var guard = 0;
    while (paymentEl && guard < 20) {
      try {
        paymentEl.remove();
      } catch (e) {
        /* ignore */
      }
      paymentEl = form.querySelector(paymentSelectors);
      guard++;
    }

    // --- Step 5: Fallback insertion ---
    // If Step 1 couldn't find a native ATC to swap with (very old / very
    // custom theme), drop the button into a known buttons container or at
    // the end of the form.
    if (!form.querySelector("." + BTN_CLASS)) {
      insertCustomBtnFallback(form);
      log("POD button inserted via fallback");
    }

    // --- Wire variant change listeners (once per element) ---
    // When a user picks a variant, themes often re‑render the buy row,
    // which can drop our button. We re‑run on variant interactions.
    document
      .querySelectorAll(
        "button[data-action='select-value']," +
          ".product-form__input input[type=radio]," +
          ".product-form__input input[type=checkbox]," +
          "select[name='id']," +
          "select[name^='options']," +
          "input[name='id']"
      )
      .forEach(function (variant) {
        if (variant.getAttribute("data-pod-vwired") === "1") return;
        variant.setAttribute("data-pod-vwired", "1");
        var rerun = function () {
          setTimeout(replaceWithCustomAddToCartButton, 200);
        };
        variant.addEventListener("click", rerun);
        variant.addEventListener("change", rerun);
      });
  }

  // ── Cart Property Hiding ──────────────────────────────────────

  /**
   * Hide internal POD properties from cart line items.
   * Shopify hides `_`-prefixed properties natively, but some themes
   * override that. This function is a CSS-level safety net.
   * Legacy names (canvasid, portalurl, unique_key, created at) are
   * kept for backward compat with items already in customer carts.
   */
  function hideCartProperties() {
    document.querySelectorAll(".cart__item,.cart-item").forEach(function (item) {
      item
        .querySelectorAll("li,.cart__property,.product-option")
        .forEach(function (row) {
          var text = (row.textContent || "").toLowerCase();
          if (
            text.indexOf("_pod_session_id") !== -1 ||
            text.indexOf("_pod_preview") !== -1 ||
            text.indexOf("_pod_product_id") !== -1 ||
            text.indexOf("_pod_customization_fee") !== -1 ||
            text.indexOf("_pod_customized_sides") !== -1 ||
            text.indexOf("_pod_base_price") !== -1 ||
            text.indexOf("_pod_customization_fee_line") !== -1 ||
            text.indexOf("_timestamp") !== -1 ||
            text.indexOf("_unique_key") !== -1 ||
            text.indexOf("unique_key") !== -1 ||
            text.indexOf("created at") !== -1 ||
            text.indexOf("canvasid") !== -1 ||
            text.indexOf("portalurl") !== -1
          ) {
            row.style.display = "none";
          }
        });
    });
  }

  // ── Shopify Routes Helper ─────────────────────────────────────

  function getShopifyRoot() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return String(Shopify.routes.root);
      }
    } catch (e) {
      /* ignore */
    }
    return "/";
  }

  /**
   * Resolve the hidden fee variant used to add customization surcharges at checkout.
   * Baked into __POD_CFG on theme deploy; falls back to live API if missing.
   */
  function fetchFeeConfig() {
    if (FEE_VARIANT_ID) {
      return Promise.resolve({ id: FEE_VARIANT_ID, unit: FEE_VARIANT_UNIT });
    }
    if (!SHOP_DOMAIN || !POD_EDGE_URL) {
      return Promise.resolve(null);
    }
    return fetch(
      POD_EDGE_URL +
        "/api/shop-cart-config?shop=" +
        encodeURIComponent(SHOP_DOMAIN)
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var id = data && data.customizationFeeVariantId
          ? String(data.customizationFeeVariantId).trim()
          : "";
        if (!id) return null;
        var unit = parseFloat(data.customizationFeeVariantUnit);
        return {
          id: id,
          unit: unit > 0 ? unit : 0.01,
        };
      })
      .catch(function () {
        return null;
      });
  }

  function normalizeLineProperties(props) {
    if (!props) return {};
    if (Array.isArray(props)) {
      var out = {};
      for (var i = 0; i < props.length; i++) {
        var p = props[i];
        if (p && p.name != null) out[String(p.name)] = p.value;
      }
      return out;
    }
    return props;
  }

  function ensurePodCartStyles() {
    if (document.getElementById("pod-cart-price-styles")) return;
    var style = document.createElement("style");
    style.id = "pod-cart-price-styles";
    style.textContent = ".pod-fee-line-hidden{display:none!important;}";
    document.head.appendChild(style);
  }

  function findCartRowForLineItem(item, fallbackRow) {
    if (!item) return fallbackRow || null;
    var key = item.key ? String(item.key) : "";
    if (key) {
      var keySelectors = [
        '[data-cart-item-key="' + key + '"]',
        '[data-key="' + key + '"]',
        '[id="CartItem-' + key + '"]',
      ];
      for (var s = 0; s < keySelectors.length; s++) {
        try {
          var keyed = document.querySelector(keySelectors[s]);
          if (keyed) {
            return (
              keyed.closest(
                ".cart-item, .cart__item, .cart__row, tr.cart-item, [data-cart-item], cart-item"
              ) || keyed
            );
          }
        } catch (e) {
          /* invalid selector */
        }
      }
    }
    var vid = item.variant_id != null ? String(item.variant_id) : "";
    if (vid) {
      var links = document.querySelectorAll(
        'a[href*="/variants/' + vid + '"], a[href*="variant=' + vid + '"]'
      );
      if (links.length) {
        var fromLink = links[0].closest(
          ".cart-item, .cart__item, .cart__row, tr.cart-item, [data-cart-item], cart-item"
        );
        if (fromLink) return fromLink;
      }
    }
    return fallbackRow || null;
  }

  function updatePriceElements(root, unitStr, lineStr, quantity) {
    if (!root) return;
    root
      .querySelectorAll(
        ".price, .cart-item__price, .cart__price, .product-option, .cart-item__totals, .line-item__price, .cart-item__final-price, [data-cart-item-price], [data-cart-item-total]"
      )
      .forEach(function (el) {
        var text = (el.textContent || "").trim();
        if (!text || text.indexOf("$") === -1) return;
        if (quantity > 1 && text.indexOf("×") !== -1) {
          el.textContent = unitStr + " × " + quantity;
        } else {
          el.textContent = quantity > 1 ? lineStr : unitStr;
        }
      });
  }

  function schedulePodCartPriceDisplay() {
    [0, 250, 700, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        applyPodCartPriceDisplay();
      }, delay);
    });
  }

  function formatMoneyFromCents(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      var currency =
        window.Shopify && Shopify.currency && Shopify.currency.active
          ? Shopify.currency.active
          : "USD";
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
      }).format(amount);
    } catch (e) {
      return "$" + amount.toFixed(2);
    }
  }

  /**
   * Shopify cart lines always show the catalog variant price ($6).
   * POD items carry `_pod_customization_fee` — update the cart UI so shoppers
   * see shirt + customization (e.g. $11) and hide the companion fee line item.
   */
  function applyPodCartPriceDisplay() {
    ensurePodCartStyles();
    var ROOT = getShopifyRoot();
    return fetch(ROOT + "cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

        var displaySubtotalCents = 0;
        var rows = document.querySelectorAll(
          ".cart-item, .cart__item, .cart__row, tr.cart-item, [data-cart-item], cart-item"
        );

        cart.items.forEach(function (item, idx) {
          var props = normalizeLineProperties(item.properties);
          var isFeeLine = props._pod_customization_fee_line === "1";

          if (isFeeLine) {
            displaySubtotalCents += item.final_line_price;
            var feeRow = findCartRowForLineItem(item, rows[idx]);
            if (feeRow) {
              feeRow.style.display = "none";
              feeRow.classList.add("pod-fee-line-hidden");
            }
            return;
          }

          var feePerUnit = parseFloat(props._pod_customization_fee) || 0;
          if (props._pod_priced_variant === "1") {
            displaySubtotalCents += item.final_line_price;
            return;
          }

          var feeCents = Math.round(feePerUnit * 100);
          var unitCents = item.price + feeCents;
          var lineCents = unitCents * item.quantity;
          displaySubtotalCents += feePerUnit > 0 ? lineCents : item.final_line_price;

          if (feePerUnit <= 0) return;

          var row = findCartRowForLineItem(item, rows[idx]);
          if (!row) return;

          var unitStr = formatMoneyFromCents(unitCents);
          var lineStr = formatMoneyFromCents(lineCents);
          updatePriceElements(row, unitStr, lineStr, item.quantity);
        });

        var subtotalStr = formatMoneyFromCents(displaySubtotalCents);
        document
          .querySelectorAll(
            ".totals__subtotal-value, .cart__subtotal, .cart-subtotal, [data-cart-subtotal], .cart__footer .totals p, .totals__subtotal, [data-checkout-subtotal-price]"
          )
          .forEach(function (el) {
            if ((el.textContent || "").indexOf("$") !== -1) {
              el.textContent = subtotalStr;
            }
          });
      })
      .catch(function (e) {
        console.warn(TAG, "applyPodCartPriceDisplay", e);
      });
  }

  /**
   * `/cart?items=...` is also used by the unified theme script (`dtf.js`): GangSheet sends
   * `{ id, variantId, quantity }` (canvas id, no productId), DTF-by-size uses `source=dtfbysize`,
   * Upload GangSheet uses `ugsCheckout` + `source=uploadgangsheet_prepare`.
   * Only run the POD designer cart handler when every line references a product id in
   * `PODenabledProductList` so we never overwrite those flows with `_pod_*` properties.
   */
  function shouldPodScriptHandleCartQuery(params, itemsParam) {
    if (!itemsParam) return false;
    var source = (params.get("source") || "").trim().toLowerCase();
    if (source === "pod") return true;
    if (source === "dtfbysize" || source === "uploadgangsheet_prepare") {
      return false;
    }
    if (params.get("ugsCheckout")) {
      return false;
    }
    var rows;
    try {
      rows = JSON.parse(itemsParam);
    } catch (e) {
      return false;
    }
    if (!Array.isArray(rows) || !rows.length) return false;
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || typeof row !== "object") return false;
      if (row.sessionId || parseFloat(row.customizationFeePerUnit) > 0) {
        continue;
      }
      var pid = row.productId != null ? normalizeId(row.productId) : "";
      if (!pid || !isProductInEnabledList(pid)) {
        return false;
      }
    }
    return true;
  }

  // ── Priced variant creation (automatic — no manual fee product per store) ──

  function podSleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function showPodCartUpdatingOverlay() {
    if (document.getElementById("pod-cart-updating")) return;
    var el = document.createElement("div");
    el.id = "pod-cart-updating";
    el.style.cssText =
      "position:fixed;inset:0;z-index:999999;background:rgba(255,255,255,0.92);" +
      "display:flex;align-items:center;justify-content:center;font:600 16px/1.4 system-ui,sans-serif;color:#111;";
    el.textContent = "Updating your cart…";
    document.body.appendChild(el);
  }

  function hidePodCartUpdatingOverlay() {
    var el = document.getElementById("pod-cart-updating");
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function podResolveUnitPrice(item) {
    var feePerUnit = parseFloat(item.customizationFeePerUnit) || 0;
    var explicit = parseFloat(item.price);
    if (!isNaN(explicit) && explicit > 0) return explicit;
    var base = parseFloat(item.basePrice);
    if (!isNaN(base) && base >= 0) return base + feePerUnit;
    return feePerUnit > 0 ? feePerUnit : 0;
  }

  function podItemNeedsPricedVariant(item) {
    if (item.prePriced === true || item.prePriced === "1") return false;
    var feePerUnit = parseFloat(item.customizationFeePerUnit) || 0;
    if (feePerUnit > 0) return true;
    var explicit = parseFloat(item.price);
    var base = parseFloat(item.basePrice);
    if (!isNaN(explicit) && !isNaN(base) && explicit > base + 0.001) return true;
    return false;
  }

  function podCreatePricedVariantWithRetries(item, unitPrice, runtimeShopId) {
    if (!POD_EDGE_URL) {
      return Promise.resolve({ ok: false, error: "POD edge URL not configured" });
    }
    var url = POD_EDGE_URL + "/api/create-priced-variant";
    var payload = {
      shopId: runtimeShopId || _resolvedShopId || shopID || "",
      shop: SHOP_DOMAIN || "",
      baseVariantId: item.variantId,
      price: unitPrice,
      sessionId: item.sessionId || item.id || "",
    };
    if (!payload.shopId && !payload.shop) {
      return Promise.resolve({ ok: false, error: "Shop not configured in theme script" });
    }
    var maxAttempts = 3;
    var delays = [0, 800, 2000];
    var attempt = 0;

    function run() {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { status: r.status, data: data };
          });
        })
        .then(function (out) {
          if (out.data && out.data.success && out.data.variantId) {
            return { ok: true, variantId: String(out.data.variantId) };
          }
          var err =
            (out.data && out.data.error) ||
            "Variant creation failed (" + out.status + ")";
          var retryable = out.status >= 500 || out.status === 429;
          if (retryable && attempt < maxAttempts - 1) {
            attempt++;
            return podSleep(delays[attempt] || 2000).then(run);
          }
          return { ok: false, error: err };
        })
        .catch(function (e) {
          if (attempt < maxAttempts - 1) {
            attempt++;
            return podSleep(delays[attempt] || 2000).then(run);
          }
          return { ok: false, error: String(e) };
        });
    }
    return run();
  }

  function podCreatePricedVariantsForItems(items) {
    return resolveRuntimeShopId().then(function (runtimeShopId) {
      var tasks = items.map(function (item) {
        if (!podItemNeedsPricedVariant(item)) {
          return Promise.resolve(item);
        }
        var unitPrice = podResolveUnitPrice(item);
        if (!(unitPrice > 0)) return Promise.resolve(item);
        return podCreatePricedVariantWithRetries(item, unitPrice, runtimeShopId).then(
          function (out) {
            if (out.ok && out.variantId) {
              return Object.assign({}, item, {
                variantId: out.variantId,
                _pod_priced_variant: "1",
              });
            }
            console.error(TAG, "priced variant creation failed", out.error);
            return item;
          }
        );
      });
      return Promise.all(tasks);
    });
  }

  function podCartAddWithRetries(items) {
    var ROOT = getShopifyRoot();
    var maxAttempts = 12;
    var betweenDelays = [400, 550, 750, 1000, 1300, 1700, 2100, 2600, 3200, 4000, 5000];
    var attempt = 0;

    function run() {
      return fetch(ROOT + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { res: res, data: data };
          });
        })
        .then(function (out) {
          if (out.res.ok) return out;
          var msg = (
            (out.data && (out.data.message || out.data.description)) ||
            ""
          ).toLowerCase();
          var retryable =
            out.res.status === 422 &&
            (msg.indexOf("sold out") !== -1 ||
              msg.indexOf("out of stock") !== -1 ||
              msg.indexOf("unavailable") !== -1 ||
              msg.indexOf("not available") !== -1 ||
              msg.indexOf("could not be added") !== -1);
          if (retryable && attempt < maxAttempts - 1) {
            attempt++;
            return podSleep(betweenDelays[attempt - 1] || 3000).then(run);
          }
          return out;
        });
    }
    return run();
  }

  // ── Cart Add Flow ─────────────────────────────────────────────
  // When the designer finishes, it redirects to /cart?items=[...]&oldVariantId=...
  // This function processes those params and adds items to the Shopify cart.

  function handleCartAdd() {
    if (window.__podCartBusy) return Promise.resolve();

    var params = new URLSearchParams(window.location.search || "");
    var itemsParam = params.get("items");
    var oldVariantId = params.get("oldVariantId");
    if (!itemsParam) return Promise.resolve();
    if (!shouldPodScriptHandleCartQuery(params, itemsParam)) {
      return Promise.resolve();
    }

    // Deduplicate: prevent double‑add if page reloads with same params
    var STORAGE_KEY = "pod_cart_add";
    var DEDUP_TTL = 120000; // 2 minutes
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed.p === itemsParam && Date.now() - parsed.t < DEDUP_TTL) {
          var cleanPath = window.location.pathname;
          if (window.history && history.replaceState) {
            history.replaceState({}, "", cleanPath);
          }
          window.location.replace(cleanPath);
          return Promise.resolve();
        }
      }
    } catch (e) {
      /* ignore */
    }

    window.__podCartBusy = true;
    var cleanUrl = window.location.pathname;

    var addedItems;
    try {
      addedItems = JSON.parse(itemsParam);
    } catch (e) {
      window.__podCartBusy = false;
      return Promise.resolve();
    }
    if (!Array.isArray(addedItems) || !addedItems.length) {
      window.__podCartBusy = false;
      return Promise.resolve();
    }

    // Clean the URL immediately so refreshes don't re‑add (params captured above).
    if (window.history && history.replaceState) {
      history.replaceState({}, "", cleanUrl);
    }

    var ROOT = getShopifyRoot();
    showPodCartUpdatingOverlay();

    return podCreatePricedVariantsForItems(addedItems)
      .then(function (pricedItems) {
        return fetch(ROOT + "cart.js")
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return { items: [] };
          })
          .then(function (cart) {
            cart = cart || { items: [] };
            var removalPromises = [];

            if (
              oldVariantId &&
              oldVariantId !== "undefined" &&
              oldVariantId !== "null"
            ) {
              for (var i = 0; i < cart.items.length; i++) {
                var cartItem = cart.items[i];
                if (
                  String(cartItem.variant_id) === String(oldVariantId) &&
                  !(cartItem.properties && cartItem.properties._pod_session_id)
                ) {
                  removalPromises.push(
                    fetch(ROOT + "cart/change.js", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ id: cartItem.key, quantity: 0 }),
                    }).catch(function (e) {
                      console.error(TAG, "cart/change error", e);
                    })
                  );
                }
              }
            }
            return Promise.all(removalPromises).then(function () {
              return pricedItems;
            });
          });
      })
      .then(function (pricedItems) {
        var lineItems = [];

        for (var i = 0; i < pricedItems.length; i++) {
          var timestamp = Date.now() + i * 1000;
          var item = pricedItems[i];
          var qty = parseInt(item.quantity, 10) || 1;
          var feePerUnit = parseFloat(item.customizationFeePerUnit) || 0;

          var props = {
            _pod_session_id: item.sessionId || item.id || "",
            _pod_preview: item.previewUrl || "",
            _pod_product_id: item.productId || "",
            _timestamp: timestamp,
            _unique_key: String(item.variantId) + "_" + timestamp,
          };
          if (feePerUnit > 0) {
            props._pod_customization_fee = String(feePerUnit);
            if (item.basePrice != null && !isNaN(parseFloat(item.basePrice))) {
              props._pod_base_price = String(item.basePrice);
            }
            if (
              Array.isArray(item.customizedViewsOrdered) &&
              item.customizedViewsOrdered.length
            ) {
              props._pod_customized_sides = item.customizedViewsOrdered.join(",");
            }
          }
          if (item._pod_priced_variant === "1") {
            props._pod_priced_variant = "1";
          }
          if (item.prePriced === true || item.prePriced === "1") {
            props._pod_priced_variant = "1";
          }

          lineItems.push({
            id: item.variantId,
            quantity: qty,
            properties: props,
          });
        }

        return podCartAddWithRetries(lineItems);
      })
      .then(function (out) {
        hidePodCartUpdatingOverlay();
        if (out && out.res && out.res.ok) {
          try {
            localStorage.setItem(
              STORAGE_KEY,
              JSON.stringify({ p: itemsParam, t: Date.now() })
            );
          } catch (e) {
            /* ignore */
          }
          window.location.replace(cleanUrl);
          return;
        }
        window.__podCartBusy = false;
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          /* ignore */
        }
        console.error(
          TAG,
          "cart/add failed",
          out && out.res && out.res.status,
          out && out.data
        );
        alert(
          "Could not add your customized item to the cart. Please try again from the designer."
        );
      })
      .catch(function (e) {
        hidePodCartUpdatingOverlay();
        window.__podCartBusy = false;
        console.error(TAG, "cart flow error", e);
      });
  }

  // ── Cart Permalink Handling ───────────────────────────────────
  // Shopify cart permalinks: /cart/variantId:quantity,variantId:quantity

  function handleCartPermalink() {
    var match = (window.location.pathname || "").match(
      /\/cart\/(\d+:\d+(,\d+:\d+)*)$/
    );
    if (!match) return false;

    var STORAGE_KEY = "pod_permalink";
    var DEDUP_TTL = 120000;
    var currentPath = window.location.pathname;
    var cartPath = currentPath.split("/cart")[0] + "/cart";

    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed.p === currentPath && Date.now() - parsed.t < DEDUP_TTL) {
          window.location.replace(cartPath);
          return true;
        }
      }
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ p: currentPath, t: Date.now() })
      );
    } catch (e) {
      /* ignore */
    }

    window.location.replace(cartPath);
    return true;
  }

  // ── Designer Modal ────────────────────────────────────────────

  // ── Body-scroll lock helpers ──────────────────────────────────
  // When the designer modal is open the Shopify page must not scroll.
  // We save/restore `scrollY` so the page doesn't jump when unlocking.

  var _bodyScrollLockY = 0;

  function lockBodyScroll() {
    _bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + _bodyScrollLockY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
  }

  function unlockBodyScroll() {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    // Restore the scroll position that was active before locking.
    window.scrollTo(0, _bodyScrollLockY);
  }

  function removeCloseConfirm() {
    var overlay = document.getElementById(CONFIRM_ID);
    if (overlay) overlay.remove();
  }

  /** User must confirm before leaving the POD designer overlay. */
  function showDesignerCloseConfirm(onYes) {
    removeCloseConfirm();
    var outer = document.createElement("div");
    outer.id = CONFIRM_ID;
    outer.setAttribute("role", "dialog");
    outer.setAttribute("aria-modal", "true");
    outer.setAttribute("aria-labelledby", "pod-close-confirm-title");
    outer.style.cssText =
      "position:fixed;top:0;right:0;bottom:0;left:0;z-index:10000001;" +
      "background:rgba(15,23,42,0.5);display:flex;align-items:center;justify-content:center;" +
      "padding:24px;box-sizing:border-box;font-family:system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",sans-serif;";
    outer.addEventListener("click", function (ev) {
      if (ev.target === outer) removeCloseConfirm();
    });

    var card = document.createElement("div");
    card.style.cssText =
      "max-width:400px;width:100%;background:#fff;border-radius:12px;padding:24px;" +
      "box-shadow:0 25px 50px rgba(0,0,0,0.22);";

    var h = document.createElement("div");
    h.id = "pod-close-confirm-title";
    h.textContent = "Are you sure you want to close?";
    h.style.cssText = "margin:0 0 10px;font-size:18px;font-weight:600;color:#0f172a;";

    var p = document.createElement("p");
    p.textContent = "You might lose your work.";
    p.style.cssText = "margin:0 0 22px;font-size:14px;line-height:1.5;color:#475569;";

    var row = document.createElement("div");
    row.style.cssText = "display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap;";

    var noBtn = document.createElement("button");
    noBtn.type = "button";
    noBtn.textContent = "No";
    noBtn.style.cssText =
      "cursor:pointer;border-radius:8px;padding:10px 18px;font-size:14px;font-weight:600;" +
      "border:1px solid #cbd5e1;background:#fff;color:#334155;";
    noBtn.onclick = function () {
      removeCloseConfirm();
    };

    var yesBtn = document.createElement("button");
    yesBtn.type = "button";
    yesBtn.textContent = "Yes";
    yesBtn.style.cssText =
      "cursor:pointer;border-radius:8px;padding:10px 18px;font-size:14px;font-weight:600;" +
      "border:none;background:#0f172a;color:#fff;";
    yesBtn.onclick = function () {
      removeCloseConfirm();
      if (typeof onYes === "function") onYes();
    };

    row.appendChild(noBtn);
    row.appendChild(yesBtn);
    card.appendChild(h);
    card.appendChild(p);
    card.appendChild(row);
    outer.appendChild(card);
    document.body.appendChild(outer);
  }

  function clearModal() {
    removeCloseConfirm();
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.remove();
    unlockBodyScroll();
  }

  /**
   * Open the POD designer in a full-screen iframe modal.
   *
   * Modal structure (column flex, position:fixed fills viewport):
   *   ┌─ modal (fixed, inset:0, flex-col) ─────────────────┐
   *   │  ┌─ iframe (flex:1, height:0 → grows to fill) ───┐  │
   *   │  │  designer content                             │  │
   *   │  └───────────────────────────────────────────────┘  │
   *   └─────────────────────────────────────────────────────┘
   *
   * Body scroll is locked while the modal is visible so the Shopify
   * product page cannot be scrolled behind the designer.
   */
  function openDesigner(productId, variantId, quantity) {
    if (!APP_URL || !/^https?:\/\//i.test(APP_URL)) {
      console.error(TAG, "POD_APP_URL not configured");
      alert("Designer not available. Contact the store owner.");
      return;
    }

    var designerUrl =
      APP_URL +
      "/iframe/product/" +
      encodeURIComponent(productId || "") +
      "?shop=" +
      encodeURIComponent(SHOP_DOMAIN) +
      "&variantId=" +
      encodeURIComponent(variantId || "") +
      "&shopId=" +
      encodeURIComponent(shopID || "") +
      "&url=" +
      encodeURIComponent(window.location.origin) +
      "&quantity=" +
      encodeURIComponent(String(quantity || 1)) +
      "&productId=" +
      encodeURIComponent(productId || "");

    clearModal();

    var modal = document.createElement("div");
    modal.id = MODAL_ID;
    // position:fixed + inset:0 covers the full visual viewport on all
    // mobile browsers including iOS Safari with its dynamic toolbar.
    modal.style.cssText =
      "position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100%;" +
      "z-index:999999;background:#fff;display:flex;flex-direction:column;" +
      "overflow:hidden;";

    var chromeRow = document.createElement("div");
    chromeRow.style.cssText =
      "flex-shrink:0;display:flex;align-items:center;justify-content:flex-end;" +
      "min-height:48px;padding:6px 10px;border-bottom:1px solid #e2e8f0;background:#fff;";
    var closeChrome = document.createElement("button");
    closeChrome.type = "button";
    closeChrome.textContent = "Close";
    closeChrome.setAttribute("aria-label", "Close designer");
    closeChrome.style.cssText =
      "cursor:pointer;border:none;background:transparent;font-size:14px;font-weight:600;color:#2563eb;padding:8px 12px;border-radius:8px;";
    closeChrome.onmouseenter = function () {
      closeChrome.style.background = "#eff6ff";
    };
    closeChrome.onmouseleave = function () {
      closeChrome.style.background = "transparent";
    };
    closeChrome.onclick = function () {
      showDesignerCloseConfirm(clearModal);
    };
    chromeRow.appendChild(closeChrome);
    modal.appendChild(chromeRow);

    var iframe = document.createElement("iframe");
    iframe.src = designerUrl;
    iframe.title = "POD designer";
    iframe.setAttribute(
      "allow",
      "clipboard-read; clipboard-write; fullscreen"
    );
    // flex:1 makes the iframe grow to fill the modal height.
    // height:0 is the standard companion to flex:1 for iframes — without it
    // some mobile browsers use the iframe's intrinsic content height instead
    // of the flex-allocated height, leaving a gap at the bottom.
    iframe.style.cssText =
      "flex:1 1 0;width:100%;height:0;min-height:0;border:none;display:block;";

    modal.appendChild(iframe);
    document.body.appendChild(modal);

    // Lock the Shopify page scroll AFTER the modal is in the DOM.
    lockBodyScroll();
  }

  // ── PostMessage Listener (designer ↔ storefront) ──────────────

  window.addEventListener("message", function (event) {
    if (!event.data || typeof event.data !== "object") return;

    // Designer requests to close — same UX as storefront “Close”.
    if (event.data.type === "print-studio-iframe-close") {
      showDesignerCloseConfirm(clearModal);
    }

    // Designer finalized a session and wants to add to cart directly
    if (event.data.type === "pod-add-to-cart") {
      var msg = event.data;
      var vid = String(msg.variantId || "").trim();
      if (!vid) {
        log("pod-add-to-cart: missing variantId");
        return;
      }
      var qty = parseInt(msg.quantity, 10) || 1;
      var ROOT = getShopifyRoot();

      var props = {};
      if (msg.sessionId) props._pod_session_id = String(msg.sessionId);
      if (msg.previewUrl) props._pod_preview = String(msg.previewUrl);
      if (msg.productId) props._pod_product_id = String(msg.productId);
      props._timestamp = Date.now();

      var feePerUnit = parseFloat(msg.customizationFeePerUnit) || 0;
      if (feePerUnit > 0) {
        props._pod_customization_fee = String(feePerUnit);
        if (msg.basePrice != null && !isNaN(parseFloat(msg.basePrice))) {
          props._pod_base_price = String(msg.basePrice);
        }
        if (Array.isArray(msg.customizedViewsOrdered) && msg.customizedViewsOrdered.length) {
          props._pod_customized_sides = msg.customizedViewsOrdered.join(",");
        }
      }

      var cartItem = {
        variantId: vid,
        quantity: qty,
        sessionId: msg.sessionId || "",
        customizationFeePerUnit: feePerUnit,
        basePrice: msg.basePrice,
        price: msg.price,
        id: msg.sessionId || vid,
      };

      showPodCartUpdatingOverlay();
      podCreatePricedVariantsForItems([cartItem])
        .then(function (resolved) {
          var item = resolved[0] || cartItem;
          var finalVid = parseInt(item.variantId, 10) || item.variantId;
          if (item._pod_priced_variant === "1") {
            props._pod_priced_variant = "1";
          }
          return podCartAddWithRetries([
            {
              id: finalVid,
              quantity: qty,
              properties: props,
            },
          ]);
        })
        .then(function (out) {
          hidePodCartUpdatingOverlay();
          log("pod-add-to-cart", {
            variantId: vid,
            quantity: qty,
            sessionId: msg.sessionId,
            customizationFeePerUnit: feePerUnit,
          });
          if (out && out.res && out.res.ok) {
            clearModal();
            window.location.href = ROOT + "cart";
          } else {
            console.error(TAG, "cart/add.js failed", out && out.res && out.res.status);
          }
        })
        .catch(function (e) {
          hidePodCartUpdatingOverlay();
          console.error(TAG, "cart/add.js error", e);
        });
    }
  });

  // ── Main Runner ───────────────────────────────────────────────

  function runner() {
    var pathname = window.location.pathname || "";

    // Product page: replace buy button with designer button
    if (pathname.indexOf("/products/") !== -1) {
      var pid = getProductId() || getProductVariantFromAnalytics().productId;
      if (!pid) {
        log("waiting for product id");
        return Promise.resolve();
      }
      if (isDebug) {
        console.info(TAG, "check", {
          id: pid,
          enabled: isCurrentProductEnabled(),
          listLength: enabledList.length,
        });
      }
      if (isCurrentProductEnabled()) {
        replaceWithCustomAddToCartButton();
      }
      return Promise.resolve();
    }

    // Cart page: process cart add flow or permalink redirect
    if (pathname.indexOf("/cart") !== -1) {
      if (handleCartPermalink()) return Promise.resolve();
      return handleCartAdd();
    }

    return Promise.resolve();
  }

  function init() {
    runner()
      .then(hideCartProperties)
      .then(function () {
        if ((window.location.pathname || "").indexOf("/cart") !== -1) {
          schedulePodCartPriceDisplay();
        }
      })
      .catch(function (e) {
        console.error(TAG, "runner error", e);
      });
  }

  function scheduleInit() {
    setTimeout(init, 100);
  }

  // ── Lifecycle: Run on Page Load ───────────────────────────────

  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    scheduleInit();
  }
  document.addEventListener("DOMContentLoaded", scheduleInit);
  window.addEventListener("load", function () {
    setTimeout(init, 200);
  });

  // Poll for ShopifyAnalytics availability — some themes load it late.
  // BOUNDED: stops after 15s whether or not analytics ever appears. This is
  // the ONLY timer on the page after load; it self‑clears and never re‑runs.
  var analyticsPoller = setInterval(function () {
    if (getProductVariantFromAnalytics().productId) {
      clearInterval(analyticsPoller);
      scheduleInit();
    }
  }, 500);
  setTimeout(function () {
    clearInterval(analyticsPoller);
  }, 15000);

  // ── Click Delegation: Custom Button ───────────────────────────

  // Capture phase + stopImmediatePropagation so other storefront snippets
  // (e.g. GangSheet on `document`) never see this click.
  var POD_BTN_SEL =
    "." + BTN_CLASS + "[" + BTN_DATA_ATTR + '="1"]';

  document.addEventListener(
    "click",
    function (event) {
    var btn =
      event.target && event.target.closest
        ? event.target.closest(POD_BTN_SEL)
        : null;
    if (!btn) return;
    if (!isCurrentProductEnabled()) {
      log("click ignored: product not in enabled list");
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var form = btn.closest("form") || document.querySelector(
      'form[action="/cart/add"],form[action*="/cart/add"]'
    );
    var analytics = getProductVariantFromAnalytics();
    var productId = analytics.productId || getProductId();
    var variantId = (form && getVariantId(form)) || analytics.variantId;
    var quantity = 1;

    // Read quantity from form input if available
    if (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput && qtyInput.value) {
        var parsed = parseInt(qtyInput.value, 10);
        quantity = parsed > 0 ? parsed : 1;
      }
    }

    console.info(TAG, "click", {
      productId: productId,
      variantId: variantId,
      quantity: quantity,
    });

    if (!productId || !variantId) {
      alert("Unable to open builder. Please refresh.");
      return;
    }

    openDesigner(productId, variantId, quantity);
    },
    true
  );

  // ── Debug Info ────────────────────────────────────────────────

  if (isDebug) {
    console.info(TAG, "loaded", {
      shop: SHOP_DOMAIN,
      enabledProducts: enabledList.length,
      hasApp: !!APP_URL,
    });
  }
})();